import React, { useState } from "react";
import {
    Box, Typography, Accordion, AccordionSummary, AccordionDetails,
    Button, Grid
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { NavLink, Outlet, useRouteLoaderData } from "react-router-dom";
import { showSnackbar } from "../../../../components/snackbarUtils";
import api from "../../../../hooks/useApi";
import PageTitle from "../../../../components/PageTitle";

export default function ObjectChildrenAgePayments() {
    const layoutLoader = useRouteLoaderData("obj_layout");
    const hotelObjs = layoutLoader?.hotelObj?.children_obj || [];
    const hotelObj = layoutLoader?.hotelObj || {};
    const [expanded, setExpanded] = useState(null);

    const handleExpand = (panel) => (_, isExpanded) => {
        setExpanded(isExpanded ? panel : null);
    };

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const handleDelete = async (agePaymentId) => {
        try {
            const response = await api.delete(`/api/AgePayment/${agePaymentId}/`);

            if (response.status >= 204 && response.status < 300) {
                showSnackbar("Дитячий тариф успішно видалено!", "success", {
                    sx: { backgroundColor: "#1de416", color: "white" }
                });
                await sleep(1500);
                window.location.href = `/object/${hotelObj.id}/children_tarrifs`;
            } else {
                showSnackbar("Не вдалося видалити дитячий тариф!", "error", {
                    sx: { backgroundColor: "#b10000", color: "white" }
                });
            }
        } catch (error) {
            showSnackbar(`Не вдалося видалити дитячий тариф! ${error}`, "error", {
                sx: { backgroundColor: "#b10000", color: "white" }
            });
        }
    };

    return (
        <Box sx={{ width: "100%", p: 3 }}>
            <PageTitle title={`Тарифи для дітей: ${hotelObj?.name || hotelObj?.id || "ID"}`} />
            {hotelObjs.length === 0 ? (
                <Typography variant="h6" color="error">Немає підоб'єктів</Typography>
            ) : hotelObjs.map((hotelObj) => {
                const { age_payment_info = [] } = hotelObj;

                return (
                    <Box key={hotelObj.id} sx={{ mb: 6, pb: 2, borderBottom: "1px solid #ccc" }}>
                        <Typography variant="h5" sx={{ fontWeight: "bold" }}>{hotelObj.name}</Typography>
                        <p>{hotelObj?.service_name}</p>

                        {/* Возрастные тарифы */}
                        {age_payment_info.map((item) => (
                            <Accordion
                                key={item.id}
                                expanded={expanded === `age-${item.id}`}
                                onChange={handleExpand(`age-${item.id}`)}
                                sx={{ mt: 2 }}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>
                                        Вік: {item.from_age}–{item.to_age} — {getPaymentTypeLabel(item.payment_type)}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle2">Від:</Typography>
                                            <Typography>{item.from_age}</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle2">До:</Typography>
                                            <Typography>{item.to_age}</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2">Тип оплати:</Typography>
                                            <Typography>{getPaymentTypeLabel(item.payment_type)}</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2">Ціна:</Typography>
                                            <Typography>{parseFloat(item.price).toFixed(2)} ₴</Typography>
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ mt: 2, textAlign: "right" }}>
                                        <Button
                                            component={NavLink}
                                            to={`${item.id}/edit?id=${item.id}`}
                                            variant="contained"
                                            startIcon={<EditIcon />}
                                            sx={{ mr: 1 }}
                                        >
                                            Редагувати
                                        </Button>
                                        <Button
                                            onClick={() => handleDelete(item.id)}
                                            variant="outlined"
                                            color="error"
                                            startIcon={<DeleteIcon />}
                                        >
                                            Видалити
                                        </Button>
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        ))}

                        <Button
                            component={NavLink}
                            to={`new?children_id=${hotelObj.id}`}
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            sx={{ mt: 3 }}
                        >
                            Додати правило вікової оплати
                        </Button>
                    </Box>
                );
            })}
            <Outlet />
        </Box>
    );
}

const getPaymentTypeLabel = (key) => {
    const types = {
        "free": "Безкоштовно",
        "paid": "Платно"
    };
    return types[key] || "Невідомо";
};
